import "./App.css";
import Navbar from "./NavBar/Navbar";

function App() {
  
  return (
    <div className="App">
      <Navbar/>
    </div>
  );
}

export default App;
